import React, { useEffect, useState } from "react";
import { collection, getDocs, deleteDoc, doc } from "firebase/firestore";
import { db } from "./firebase";
import TutorLayout from "./TutorLayout";

function ViewAssignments() {
  const [assignments, setAssignments] = useState([]);
  const [students, setStudents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedIds, setSelectedIds] = useState([]);
  const toggleSelectAll = () => {
    if (selectedIds.length === assignments.length) {
      setSelectedIds([]);
    } else {
      setSelectedIds(assignments.map((a) => a.id));
    }
  };
  const toggleSelect = (id) => {
    
    
    setSelectedIds(prev =>
      prev.includes(id) ? prev.filter(i => i !== id) : [...prev, id]
    );
  };
  
  const deleteSelected = async () => {
    if (selectedIds.length === 0) return;
    const confirmed = window.confirm(`Are you sure you want to delete ${selectedIds.length} assignment(s)?`);
    if (!confirmed) return;
  
    for (const id of selectedIds) {
      await deleteDoc(doc(db, "assignments", id));
    }
  
    setAssignments(assignments.filter(a => !selectedIds.includes(a.id)));
    setSelectedIds([]);
  };
  
  useEffect(() => {
    const fetchData = async () => {
      const [assignSnap, studentSnap] = await Promise.all([
        getDocs(collection(db, "assignments")),
        getDocs(collection(db, "users"))
      ]);

      const assignmentList = assignSnap.docs
  .map(doc => ({ id: doc.id, ...doc.data() }))
  .sort((a, b) => new Date(b.createdAt || b.assignedAt || 0) - new Date(a.createdAt || a.assignedAt || 0));
      const studentList = studentSnap.docs
        .map(doc => ({
          uid: doc.id,
          name: `${doc.data().displayName || ""} ${doc.data().surname || ""}`.trim()
        }))
        .filter(s => s.uid);

      setAssignments(assignmentList);
      setStudents(studentList);
      setLoading(false);
    };

    fetchData();
  }, []);

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this assignment?")) {
      await deleteDoc(doc(db, "assignments", id));
      setAssignments(assignments.filter(a => a.id !== id));
    }
  };

  const formatDate = (d) =>
    d ? new Date(d).toLocaleDateString(undefined, { day: "numeric", month: "short", year: "numeric" }) : "";

  const getStudentName = (uid) => {
    const student = students.find(s => s.uid === uid);
    return student ? student.name : uid;
  };

  const classworkAssignments = assignments.filter(
    a =>
      (!a.assignmentType && !a.type) || // default to classwork if type is missing
      a.assignmentType === "classwork" ||
      a.type === "classwork"
  );
  
  const homeworkAssignments = assignments.filter(
    a => a.assignmentType === "homework" || a.type === "homework"
  );
  
  const renderSection = (title, list) => (
    <div style={styles.column}>
      <h2 style={styles.sectionHeading}>{title}</h2>
      {list.length === 0 ? (
        <p style={{ fontStyle: "italic" }}>No {title.toLowerCase()} assignments found.</p>
      ) : (
        <ul style={styles.list}>
          {list.map((a) => (
            <li key={a.id} style={styles.card}>
              <label style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
  <input
    type="checkbox"
    checked={selectedIds.includes(a.id)}
    onChange={() => toggleSelect(a.id)}
  />
  <strong>{a.title}</strong>
</label>

              <h3>{a.title}</h3>
              <p>
                <strong>Student:</strong> {getStudentName(a.assignedToUID)} <br />
                <strong>Subject:</strong> {a.subject} <br />
                <strong>Topic:</strong> {a.topic} — {a.subtopic} <br />
                <strong>Clip:</strong> {a.clip || "-"} <br />
              </p>
              <div style={styles.buttons}>
                <button
                  onClick={() => alert("Edit feature coming soon!")}
                  style={{ ...styles.button, backgroundColor: "#00b894" }}
                >
                  ✏️ Edit
                </button>
                <button
                  onClick={() => handleDelete(a.id)}
                  style={{ ...styles.button, backgroundColor: "#d63031" }}
                >
                  🗑 Delete
                </button>
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );

  return (
    <TutorLayout>
      <div style={styles.container}>
        <h1>📂 View Assignments</h1>
  
        {assignments.length > 0 && (
          <div style={{ marginBottom: "1rem", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <label style={{ fontWeight: "bold", fontSize: "1rem" }}>
              <input
                type="checkbox"
                checked={selectedIds.length === assignments.length}
                onChange={toggleSelectAll}
                style={{ marginRight: "0.5rem" }}
              />
              Select All Assignments
            </label>
            {selectedIds.length > 0 && (
              <button
                onClick={deleteSelected}
                style={{
                  padding: "0.6rem 1.2rem",
                  backgroundColor: "#d63031",
                  color: "white",
                  border: "none",
                  borderRadius: "6px",
                  fontWeight: "bold",
                  cursor: "pointer",
                }}
              >
                🗑 Delete Selected ({selectedIds.length})
              </button>
            )}
          </div>
        )}
  
        {loading ? (
          <p>Loading...</p>
        ) : assignments.length === 0 ? (
          <p>No assignments found.</p>
        ) : (
          <div style={{ overflowX: "auto" }}>
            <table style={{ width: "100%", borderCollapse: "collapse", backgroundColor: "#fff" }}>
              <thead style={{ backgroundColor: "#aab7b8", color: "#2c3e50" }}>
                <tr>
                  <th style={styles.th}></th>
                  <th style={styles.th}>Title</th>
                  <th style={styles.th}>Student</th>
                  <th style={styles.th}>Subject</th>
                  <th style={styles.th}>Topic</th>
                  <th style={styles.th}>Clip</th>
                  <th style={styles.th}>Assignment Type</th>
                  <th style={styles.th}>Host</th>
                </tr>
              </thead>
              <tbody>
                {assignments.map((a) => (
                  <tr key={a.id} style={styles.tr}>
                    <td style={styles.td}>
                      <input
                        type="checkbox"
                        checked={selectedIds.includes(a.id)}
                        onChange={() => toggleSelect(a.id)}
                      />
                    </td>
                    <td style={styles.td}>{a.title || "—"}</td>
                    <td style={styles.td}>{getStudentName(a.assignedToUID)}</td>
                    <td style={styles.td}>{a.subject || "—"}</td>
                    <td style={styles.td}>{`${a.topic || ""} — ${a.subtopic || ""}`}</td>
                    <td style={styles.td}>{a.clip || "—"}</td>
<td style={styles.td}>
  {a.activityType === "millionaire"
    ? "Millionaire"
    : a.activityType === "blockbusters"
    ? "Blockbusters"
    : "Self-Marked"}
</td>
<td style={styles.td}>
  {a.activityType === "millionaire" ? (
 <a
  href={`/host/${a.id}`}
  target="_blank"
  rel="noopener noreferrer"
  style={{
    display: "inline-block",
    padding: "8px 16px",
    background: "linear-gradient(135deg, #6c5ce7, #00cec9)",
    color: "#fff",
    borderRadius: "999px",
    fontWeight: "600",
    fontSize: "0.9rem",
    textDecoration: "none",
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.15)",
    transition: "all 0.3s ease",
  }}
  onMouseEnter={(e) => {
    e.target.style.transform = "scale(1.05)";
    e.target.style.boxShadow = "0 6px 12px rgba(0, 0, 0, 0.25)";
  }}
  onMouseLeave={(e) => {
    e.target.style.transform = "scale(1)";
    e.target.style.boxShadow = "0 4px 8px rgba(0, 0, 0, 0.15)";
  }}
>
  🎤 Host Live
</a>


  ) : (
    <span style={{ color: "#ccc" }}>—</span>
  )}
</td>

                    
                    
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </TutorLayout>
  );
  
  
}

const styles = {
  container: {
    padding: "2rem",
    fontFamily: "'Fredoka', cursive",
    backgroundColor: "#e9f3ff",
    minHeight: "100vh",
  },
  th: {
    padding: "12px",
    border: "1px solid #ccc",
    fontWeight: "bold",
    textAlign: "left",
    backgroundColor: "#aab7b8",
  },
  td: {
    padding: "10px",
    border: "1px solid #ddd",
    fontSize: "0.95rem",
  },
  tr: {
    backgroundColor: "#f9f9f9",
  },
  smallBtn: {
    padding: "6px 12px",
    fontSize: "0.85rem",
    borderRadius: "5px",
    border: "none",
    color: "#fff",
    cursor: "pointer",
  },
};


export default ViewAssignments;
